var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47699 22 2 17.523 2 12C2 6.47699 6.47699 2 12 2C17.523 2 22 6.47699 22 12C22 17.523 17.523 22 12 22ZM12 3.08787C7.1046 3.08787 3.08787 7.1046 3.08787 12C3.08787 16.8954 7.1046 20.9121 12 20.9121C16.8954 20.9121 20.9121 16.8954 20.9121 12C20.9121 7.1046 16.8954 3.08787 12 3.08787Z",
    fill: "#D0004B",
    stroke: "#D0004B",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68604 12.0001C6.68604 11.6766 6.9483 11.4143 7.27181 11.4143H16.7279C17.0514 11.4143 17.3137 11.6766 17.3137 12.0001C17.3137 12.3236 17.0514 12.5859 16.7279 12.5859H7.27181C6.94829 12.5859 6.68604 12.3236 6.68604 12.0001Z",
    fill: "#D0004B",
    stroke: "#D0004B",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4141 7.27205C11.4141 6.94854 11.6763 6.68628 11.9998 6.68628C12.3234 6.68628 12.5856 6.94854 12.5856 7.27205V16.7281C12.5856 17.0516 12.3234 17.3139 11.9998 17.3139C11.6763 17.3139 11.4141 17.0516 11.4141 16.7281V7.27205Z",
    fill: "#D0004B",
    stroke: "#D0004B",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/messageQuestion.604b795106424c8db583e2fc945b9ec5.svg";
export { ForwardRef as ReactComponent };